export default __webpack_public_path__ + "static/media/microfleece_v_top.3e4c18da.jpg";